module.exports = __webpack_public_path__ + "/static/assets/7222f4ddd3479a49d8bbde0c5e4e2cd8.jpeg";